var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
import { useLang } from '../../hooks/use-lang';
var cls = classNames('organisation-site-creator');
export var OrganisationSiteCreatorDefaultProps = {
  label: 'Website created by'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(1))
});
var LinkStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 500;\n    color: ", ";\n    text-decoration: none;\n  "], ["\n    font-weight: 500;\n    color: ", ";\n    text-decoration: none;\n  "])), theme.COLOR('link'))
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Link: styled.a.attrs(cls.attr('link'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Name: styled.span.attrs(cls.attr('name'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles)
};
export var OrganisationSiteCreator = function OrganisationSiteCreator(props) {
  var className = props.className,
      entity = props.entity,
      label = props.label;
  var t = useLang();
  var url = entity.url,
      name = entity.name;
  var organisationLabel = name; // TODO - add ability to use url instead

  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, label), url ? React.createElement(My.Link, {
    target: "_blank",
    href: url
  }, organisationLabel) : React.createElement(My.Name, null, organisationLabel));
};
OrganisationSiteCreator.defaultProps = OrganisationSiteCreatorDefaultProps;
OrganisationSiteCreator.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;